<template>
Not found!
</template>

<script>

export default {
  name: 'PageNotFound',
  components: {
  },
  data: () => ({
  
  }),

}

</script>